var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-rss"},[_c('img',{staticClass:"field-media",attrs:{"src":require("@/assets/images/program/program_Rss_img.png"),"alt":""}})])
}]

export { render, staticRenderFns }